module.exports = __webpack_public_path__ + "img/sr.d19ab65f.png";